import React from 'react';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import Pays from 'components/LandingPagePays';
const LandingPageWinnipegPays = props => {
  let data = props;
  return (
    <div>
      <HeadingSection title={data.heading} bgcolor="white" />
      <div className="lg:container mx-auto pt-3">
        <div className="row justify-content-center   px-lg-0 px-xl-0 px-xxl-4">
          <div className="col-md-12">
            <Pays
              imgsrc={data.imgSrc1}
              title={data.title1}
              discription={data.desc1}
              reverse={data.reverse1}
              btn={data.btn1}
              href={data.href1}
              btnTitle={data.btnTitle1}
            />
            <Pays
              imgsrc={data.imgSrc2}
              title={data.title2}
              discription={data.desc2}
              reverse={data.reverse2}
              btn={data.btn2}
              href={data.href2}
              btnTitle={data.btnTitle2}
            />
            <Pays
              imgsrc={data.imgSrc3}
              title={data.title3}
              discription={data.desc3}
              reverse={data.reverse3}
              btn={data.btn3}
              href={data.href3}
              btnTitle={data.btnTitle3}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPageWinnipegPays;
